<script setup>
  const { event, buttons } = defineProps({ event: Object, buttons: Array });
</script>

<!----------------------------------------------------------------------------->

<template>
  <WatchCard :event="event" :buttons="buttons" useBackground>
    <h2>
      <FightTitleCombo>
        <template v-slot:whiteCorner>{{ event.white_corner?.last_name ?? 'TBD' }}</template>
        <template v-slot:blackCorner>{{ event.black_corner?.last_name ?? 'TBD' }}</template>
      </FightTitleCombo>
    </h2>
    <div class="tournament">
      <h4>
        <IconPlus />
        {{ useTournamentSize(event.size) }} {{ event.tournament_title }}
      </h4>
    </div>
  </WatchCard>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  .tournament {
    display: flex;
    flex-direction: column;

    gap: 8px;
    margin: 34px 0 -16px 0;

    h4 {
      display: flex;
      align-items: center;

      @include title-s;
      font-size: px(48);

      gap: px(8);

      svg {
        width: px(14);
        margin-top: px(-6);
      }
    }

    @include break-small {
      margin: px(4) 0 0;
      h4 {
        justify-content: center;

        gap: px(5);

        svg {
          width: px(7);
          margin-top: px(-5);
        }
      }
    }

    @include break-phone {
      h4 {
        font-size: 6vw;
      }
    }
  }
</style>
